module.exports = __webpack_public_path__ + "media/application/images/icons/3-green-29218b059f73c2b1dee4fb674e70655b.svg";